import { ReactNode, useEffect, useState } from "react";

// On a change-order child the hours input holds the hours the change adds,
// so the column says so.
export const hoursHeader = (label: string, isChangeOrderChild: boolean) =>
  isChangeOrderChild ? `ADDED ${label}` : label;

const format = (n: number) => String(Math.round(n * 10000) / 10000);

interface Props {
  isChangeOrderChild: boolean;
  // From useListProjectServices: the source line's hours, or null on a line
  // the change order adds. Undefined on a line just added on the page, which
  // is also new.
  sourceHours: number | null | undefined;
  hours: string | undefined;
  // The hours input. It stays uncontrolled; Revised follows its input events.
  children: ReactNode;
}

const ChangeOrderHours = ({
  isChangeOrderChild,
  sourceHours,
  hours,
  children,
}: Props) => {
  const [added, setAdded] = useState(hours);
  useEffect(() => setAdded(hours), [hours]);

  if (!isChangeOrderChild) return <>{children}</>;

  // The input keeps the column's full width; the change-order details sit on
  // one small line under it, wrapping only when the column is narrow. A
  // spacer above, as tall as that line, keeps the input level with the row.
  if (sourceHours == null) {
    return (
      <div className="changeOrderHours">
        <div aria-hidden="true" />
        {children}
        <div className="changeOrderHoursMeta">
          <span className="changeOrderNewTag">New</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="changeOrderHours"
      onInput={(e) => setAdded((e.target as HTMLInputElement).value)}
    >
      <div aria-hidden="true" />
      {children}
      <div className="changeOrderHoursMeta">
        <span>Was {format(sourceHours)}</span>
        <span>Revised {format(sourceHours + Number(added || 0))}</span>
      </div>
    </div>
  );
};

export default ChangeOrderHours;
